var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _path2, _path3, _rect9, _path4, _path5, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 226,
    fill: "none",
    viewBox: "0 0 178 226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177.309,
    height: 225.092,
    x: 0.389,
    y: 0.4,
    fill: "#fff",
    fillOpacity: 0.15,
    rx: 10.153
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 161.269,
    height: 200.168,
    x: 8.41,
    y: 12.862,
    fill: "#fff",
    rx: 14.62
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.833,
    cy: 33.527,
    r: 4.862,
    fill: "#FF2B2A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.483,
    height: 113.455,
    x: 149.823,
    y: 30.286,
    fill: "#ECF0FC",
    rx: 3.242,
    transform: "rotate(90 149.823 30.286)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6.483,
    height: 102.11,
    x: 123.08,
    y: 44.873,
    fill: "#CAD4EC",
    rx: 3.242,
    transform: "rotate(90 123.08 44.873)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.483,
    height: 128.853,
    x: 149.823,
    y: 57.84,
    fill: "#ECF0FC",
    rx: 3.242,
    transform: "rotate(90 149.823 57.84)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 102.92,
    height: 62.4,
    x: 20.971,
    y: 78.91,
    fill: "#FF2B2A",
    rx: 4.862
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m73.203 122.638-7.15-.136c-2.314-.048-4.635.047-6.904-.445-3.452-.735-3.697-4.339-3.953-7.362a53.785 53.785 0 0 1 .45-12.791c.375-2.365 1.854-3.776 4.14-3.93 7.718-.557 15.487-.491 23.188-.231.813.024 1.632.154 2.434.302 3.959.723 4.055 4.808 4.312 8.246a48.693 48.693 0 0 1-.341 10.414c-.393 2.857-1.143 5.252-4.312 5.483-3.97.303-7.849.546-11.83.469 0-.019-.023-.019-.034-.019ZM69 115.407c2.992-1.791 5.926-3.551 8.9-5.329-2.997-1.791-5.926-3.551-8.9-5.329v10.658Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 26.743,
    height: 28.364,
    x: 129.564,
    y: 78.91,
    fill: "#FF2B2A",
    rx: 3.242
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 26.743,
    height: 28.364,
    x: 129.564,
    y: 112.946,
    fill: "#FF2B2A",
    rx: 3.242
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B2A",
    d: "M29.885 173.726a8.914 8.914 0 0 0 8.914-8.914 8.914 8.914 0 1 0-17.828 0 8.914 8.914 0 0 0 8.914 8.914Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.621,
    d: "m25.851 165.388 2.305 2.305 5.764-5.763"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.483,
    height: 110.214,
    x: 155.496,
    y: 161.57,
    fill: "#ECF0FC",
    rx: 3.242,
    transform: "rotate(90 155.496 161.57)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B2A",
    d: "M29.885 197.227a8.914 8.914 0 0 0 8.914-8.914 8.914 8.914 0 1 0-17.828 0 8.914 8.914 0 0 0 8.914 8.914Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.621,
    d: "m25.851 188.89 2.306 2.305 5.763-5.763"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 6.483,
    height: 65.642,
    x: 113.356,
    y: 185.071,
    fill: "#CAD4EC",
    rx: 3.242,
    transform: "rotate(90 113.356 185.071)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 161.269,
    height: 200.168,
    x: 8.41,
    y: 12.862,
    stroke: "#EFF0F7",
    strokeWidth: 0.81,
    rx: 14.62
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 177.062,
    height: 224.845,
    x: 0.513,
    y: 0.524,
    stroke: "#fff",
    strokeOpacity: 0.05,
    strokeWidth: 0.247,
    rx: 10.03
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d639497d55e5555adcbb2eb173b92e85.svg";
export { ForwardRef as ReactComponent };